/* Rajasthan district pins projected from lat/lng into a 460x420 SVG viewBox, plus a hand-fit state outline. */
export const DISTRICTS = [
  [217, 5, "Ganganagar"], [236, 24, "Hanumangarh"], [265, 97, "Churu"], [284, 107, "Jhunjhunu"], [272, 137, "Sikar"],
  [192, 113, "Bikaner"], [85, 176, "Jaisalmer"], [210, 161, "Nagaur"], [302, 176, "Jaipur"], [326, 177, "Dausa"],
  [339, 141, "Alwar"], [377, 159, "Bharatpur"], [395, 189, "Dholpur"], [356, 200, "Karauli"], [328, 229, "Sawai Madhopur"],
  [302, 220, "Tonk"], [250, 203, "Ajmer"], [180, 214, "Jodhpur"], [192, 242, "Pali"], [161, 266, "Jalore"],
  [106, 243, "Barmer"], [172, 292, "Sirohi"], [250, 266, "Bhilwara"], [295, 261, "Bundi"], [305, 273, "Kota"],
  [334, 280, "Baran"], [318, 309, "Jhalawar"], [250, 292, "Chittorgarh"], [217, 281, "Rajsamand"], [210, 309, "Udaipur"],
  [257, 340, "Pratapgarh"], [210, 351, "Dungarpur"], [242, 369, "Banswara"],
];

export const LABELLED = new Set(["Jaipur", "Jodhpur", "Udaipur", "Kota", "Bikaner", "Jaisalmer", "Ajmer", "Bharatpur"]);

export const OUTLINE_PATH = `
  M 216 4 L 292 26 L 340 44 L 355 88 L 378 130 L 395 176 L 400 208 L 372 236 L 359 258 L 356 296 L 340 312 L 305 335
  L 262 372 L 238 384 L 216 375 L 190 370 L 168 340 L 155 288 L 130 262 L 92 246 L 76 220 L 72 190 L 82 155 L 100 108
  L 130 60 L 175 25 Z
`;

export const LABEL_STYLE = { paintOrder: "stroke", stroke: "#7c2d12", strokeWidth: 2.4 };
